import React, { Fragment, useState, useEffect } from "react";
import { useParams, NavLink, useHistory } from "react-router-dom";
import { connect } from "react-redux";

import MakeAPICall from "../../apiCalls/common";

import {
  getPostDetailsApiRoute,
  deleteForumPostApiRoute,
  getPostCommentsApiRoute,
  addPostCommentApiRoute,
  updatePostCommentApiRoute,
  deletePostCommentApiRoute,
  addPostCommentReplyApiRoute,
  updatePostCommentReplyApiRoute,
  deletePostCommentReplyApiRoute, updateForumCommentCount
} from "../../apiRoutes";

import appRoutes from "../../routes/appRoutes";

import { getFormattedMonthDateV3 } from "../../utils/dateTimeHelper";

import Loader from "../../components/loader";
import CustomModal from "../../components/modal";
import CommentForm from "../../containers/Forum/commentForm";
import CommentsList from "../../containers/Forum/commentsList";
import { setForumReadComments, setForumReadTopics } from "../../reduxStore/actions/serverConstants";

const ForumPostDetails = props => {
  let { id } = useParams();
  let history = useHistory();
  const user = props.auth.user;

  const [isProcessing, setIsProcessing] = useState(false);
  const [apiCallParams, setApiCallParams] = useState(null);
  const [apiCallParams1, setApiCall1Params] = useState(null);
  const [apiCallParams2, setApiCall2Params] = useState(null);
  const [modalText, setModalText] = useState("");
  const [showTextModal, setShowTextModal] = useState(false);
  const [showDeletePostModal, setShowDeletePostModal] = useState(false);
  const [currFilters, setCurrFilters] = useState({
    skip: 0,
    limit: 10
  });
  const [totalComments, setTotalComments] = useState(0);

  const [postDetails, setPostDetails] = useState(null);
  const [postComments, setPostComments] = useState([]);

  const paginationUpdated = skip => {
    let newFilter = Object.assign({}, currFilters);
    newFilter.skip = skip;
    setCurrFilters(newFilter);
  };

  // get the post details
  const getPostDetails = () => {
    setIsProcessing(true);

    setApiCall2Params({
      reqType: "GET",
      reqUrl: getPostDetailsApiRoute,
      params: {
        postId: id
      },
      successCallback: res => {
        if (res.data.data) {
          let dt = res.data.data;

          if (dt.adminId) {
            dt.profilePic = dt.adminId.profilePic.original;
            dt.fullName = dt.adminId.firstName + " " + dt.adminId.lastName;
          } else if (dt.doctorId) {
            dt.fullName = "Dr " + dt.doctorId.firstName;
            if (dt.doctorId.lastName.trim() !== "") {
              dt.fullName = dt.fullName + " " + dt.doctorId.lastName.trim();
            }
            dt.profilePic = dt.doctorId.profilePic.original;
          } else {
            dt.fullName = dt.userInfo.fullName; // this needed just incase for old data
            dt.profilePic = dt.userInfo.profilePic; // this needed just incase for old data
          }

          dt.createdAt = getFormattedMonthDateV3(dt.createdAt);
          dt.message = dt.message.replace(/(?:\r\n|\r|\n)/g, "<br />");

          setPostDetails(dt);
        } else {
          setModalText(
            "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
          );
          setShowTextModal(true);
        }

        setIsProcessing(false);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  // get the comments
  const getPostComments = () => {
    setIsProcessing(true);

    let params = {
      postId: id,
      skip: currFilters.skip,
      limit: currFilters.limit
    };

    setApiCall1Params({
      reqType: "GET",
      reqUrl: getPostCommentsApiRoute,
      params: params,
      successCallback: res => {
        if (res.data.data) {
          setPostComments(res.data.data.comments);
          setTotalComments(res.data.data.totalComments);
        } else {
          setModalText(
            "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
          );
          setShowTextModal(true);
        }

        setIsProcessing(false);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  useEffect(() => {
    getPostDetails();
    markCommentAsRead();
  }, []);

  useEffect(() => {
    getPostComments();
  }, [currFilters]);

  //delete this post
  const deletePostConfirm = () => {
    setShowDeletePostModal(false);

    let formData = new FormData();
    formData.append("forumId", id);

    setIsProcessing(true);

    setApiCallParams({
      reqType: "DELETE",
      reqUrl: deleteForumPostApiRoute,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);
        history.push(appRoutes.viewForum);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  // save new comment
  const onCommentFormSubmit = comment => {
    let formData = new FormData();
    formData.append("message", comment);
    formData.append("forumId", id);
    formData.append("userId", user ? user._id : "");
    formData.append("userType", "Admin");

    setIsProcessing(true);

    setApiCallParams({
      reqType: "POST",
      reqUrl: addPostCommentApiRoute,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);
        setModalText("Comment Published Successfully");
        setShowTextModal(true);
        getPostComments();
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  // update comment
  const onCommentUpdateFormSubmit = data => {
    let formData = new FormData();
    formData.append("message", data.message);
    formData.append("commentId", data.id);

    setIsProcessing(true);

    setApiCallParams({
      reqType: "PUT",
      reqUrl: updatePostCommentApiRoute,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);
        setModalText("Comment Updated Successfully");
        setShowTextModal(true);
        getPostComments();
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  // delete comment
  const onCommentDeleteSubmit = commentId => {
    let formData = new FormData();
    formData.append("commentId", commentId);
    formData.append("forumId", id);

    setIsProcessing(true);

    setApiCallParams({
      reqType: "DELETE",
      reqUrl: deletePostCommentApiRoute,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);
        setModalText("Comment Deleted Successfully");
        setShowTextModal(true);
        getPostComments();
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  // save new comment reply
  const onCommentReplyFormSubmit = comment => {
    let formData = new FormData();
    formData.append("message", comment.message);
    formData.append("forumCommentId", comment.forumCommentId);
    formData.append("forumId", id);
    formData.append("userId", user ? user._id : "");
    formData.append("userType", "Admin");

    setIsProcessing(true);

    setApiCallParams({
      reqType: "POST",
      reqUrl: addPostCommentReplyApiRoute,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);
        setModalText("Reply Published Successfully");
        setShowTextModal(true);
        getPostComments();
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  // update comment reply
  const onCommentReplyUpdateFormSubmit = data => {
    let formData = new FormData();
    formData.append("message", data.message);
    formData.append("replyId", data.id);

    setIsProcessing(true);

    setApiCallParams({
      reqType: "PUT",
      reqUrl: updatePostCommentReplyApiRoute,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);
        setModalText("Reply Updated Successfully");
        setShowTextModal(true);
        getPostComments();
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  // delete comment reply
  const onCommentReplyDeleteSubmit = commentId => {
    let formData = new FormData();
    formData.append("replyId", commentId);
    formData.append("forumId", id);

    setIsProcessing(true);

    setApiCallParams({
      reqType: "DELETE",
      reqUrl: deletePostCommentReplyApiRoute,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);
        setModalText("Reply Deleted Successfully");
        setShowTextModal(true);
        getPostComments();
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  function markCommentAsRead() {
    setApiCallParams({
      reqType: "POST",
      reqUrl: updateForumCommentCount,
      dataObj: {
        forumId: id,
      },
      headers: {},
      successCallback: res => {
        const {
          unReadCommentCount = 0,
          unReadForumCount = 0,
          unReadReplyCommentsCount = 0
        } = res.data?.data || {};
        props.setForumReadTopics(unReadForumCount);
        props.setForumReadComments(unReadCommentCount + unReadReplyCommentsCount);

        console.log({
          setForumReadTopics: unReadForumCount,
          setForumReadComments: unReadCommentCount + unReadReplyCommentsCount
        })
      },
      failureCallback: err => {
        console.log({err})
      }
    });
  }

  return (
    <Fragment>
      {isProcessing && <Loader />}
      <div className={isProcessing ? "disableContainer" : ""}>
        <div className="view-ticket-container forum-create-post-container">
          <CustomModal
            useOneButton={true}
            cancelText="OKAY"
            openModal={showTextModal}
            cancelEvent={() => {
              setShowTextModal(false);
              setModalText("");
            }}
            modalBodyContent={<p className="text-center mb-0">{modalText}</p>}
          />
          <CustomModal
            title="Instant Consult"
            okayText="Yes"
            cancelText="No"
            openModal={showDeletePostModal}
            cancelEvent={() => {
              setShowDeletePostModal(false);
            }}
            okayEvent={deletePostConfirm}
            modalBodyContent={
              <p className="text-center mb-0">
                Are you sure you want to delete this post?
              </p>
            }
          />
          <NavLink
            to={{
              pathname: appRoutes.viewForum,
              state: {
                currPageNo:
                  props.location.state && props.location.state.currPageNo
                    ? props.location.state.currPageNo
                    : null
              }
            }}
            className="details-back-link"
            href="#"
          >
            <i className="fas fa-arrow-left"></i>{" "}
            <span className="ml-1 back-btn-text"> Back to Forum</span>
          </NavLink>
          {postDetails !== null && (
            <Fragment>
              <div className="w-100 d-flex flex-row justify-content-between align-items-end">
                <div style={{ width: "70%" }} className="mr-3">
                  <h3>{postDetails.topic}</h3>
                  <p className="user-name mb-0">
                    Date Posted: {postDetails.createdAt}&nbsp;&nbsp;&nbsp;
                    {user !== null &&
                    (user.userType === "SUPER_ADMIN" ||
                      (postDetails.adminId &&
                        user._id === postDetails.adminId._id)) ? (
                      <i
                        className="fas fa-trash-alt color-red pointer-cursor"
                        onClick={e => {
                          setShowDeletePostModal(true);
                        }}
                      ></i>
                    ) : (
                      ""
                    )}
                  </p>
                </div>

                <div
                  style={{ width: "30%" }}
                  className="d-flex justify-content-end"
                >
                  <div className="d-flex flex-column align-items-center">
                    <p className="user-name">Posted By</p>
                    <img
                      className="rounded-circle user-pic"
                      src={postDetails.profilePic}
                      alt="user-pic"
                    />
                    <p className="user-name mb-0 font-demi-bold">
                      {postDetails.fullName}
                    </p>
                  </div>
                </div>
              </div>
              <hr />
              <p dangerouslySetInnerHTML={{ __html: postDetails.message }}></p>
              <hr />
            </Fragment>
          )}
          <CommentForm user={user} onFormSubmit={onCommentFormSubmit} />
          <br />
          <br />
          <CommentsList
            user={user}
            currFilters={currFilters}
            comments={postComments}
            totalComments={totalComments}
            paginationUpdated={paginationUpdated}
            updateComment={onCommentUpdateFormSubmit}
            deleteComment={onCommentDeleteSubmit}
            addCommentReply={onCommentReplyFormSubmit}
            updateCommentReply={onCommentReplyUpdateFormSubmit}
            deleteCommentReply={onCommentReplyDeleteSubmit}
          />
          <br />
        </div>
      </div>
      {/* API Call */}
      <MakeAPICall apiParam={apiCallParams} />
      <MakeAPICall apiParam={apiCallParams1} />
      <MakeAPICall apiParam={apiCallParams2} />
    </Fragment>
  );
};

const mapDispatchToProps = dispatch => ({
  setForumReadComments: data => dispatch(setForumReadComments(data)),
  setForumReadTopics: data => dispatch(setForumReadTopics(data)),
});

const mapStateToProps = state => ({
  auth: state.auth,
  commonReducers: state.commonReducers
});

export default connect(mapStateToProps, mapDispatchToProps)(ForumPostDetails);
